import {NewsItemType} from "../types/newsItem";
import React from "react";
import LinesEllipsis from "react-lines-ellipsis";

type NewsItemProps = {
    index : number
    isVisible : boolean
    item: NewsItemType
}

function NewsItem({index, isVisible, item} : NewsItemProps) {

    const itemStyle = {
        display: isVisible ? 'flex' : 'none'
    }

    return (
        <div key={index} className="newsItem" style={itemStyle}>
            <a href={item.link} target={item.external ? '_blank' : ''}>
                <div className="newsItem__image">
                    <img src={item.image} title={item.title} alt={item.title} />
                </div>
                <div className="newsItem__info">
                    <div className="newsItem__category">
                        {item.categories.map(category => <span>{category.title}</span>)}
                    </div>

                    <div className="newsitem__headline">
                        <LinesEllipsis
                            text={item.title}
                            maxLine='3'
                            ellipsis='...'
                            trimRight
                            basedOn='letters'
                        />
                    </div>
                </div>
            </a>
        </div>
    );
}

export default NewsItem;